import { render, staticRenderFns } from "./Goody.vue?vue&type=template&id=206d2728&scoped=true&"
import script from "./Goody.vue?vue&type=script&lang=ts&"
export * from "./Goody.vue?vue&type=script&lang=ts&"
import style0 from "./Goody.vue?vue&type=style&index=0&id=206d2728&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206d2728",
  null
  
)

export default component.exports